import React, { useEffect, useState } from 'react';
import './dashboard.css';
import Toolbar from './header/Header';
import Tabs from './navbar/Navbar';
import Breadcrums from './breadcrumbs/Breadcrums';
import { Outlet, useNavigate } from "react-router-dom"
import Cookies from 'js-cookie';
import { isUserAuthenticated } from "../utils/config";

function Dashboard() {
  const isAuthenticated = isUserAuthenticated();
  const [breadcrumb,setBreadCrumb] = useState("");
  const navigate = useNavigate();

   
  let loaddatacalled = false;

  useEffect(() => {

    if (!loaddatacalled) {
      
      if (!isAuthenticated) {    
        navigate('/login');        
      }    
      loaddatacalled = true;
      
    }
  }, [isAuthenticated]);

  console.log(breadcrumb)
  return (
    <>
        <Toolbar/>
        <Tabs setBreadCrumb={setBreadCrumb} />
        <Breadcrums path={breadcrumb}/>
        <div>

          <Outlet />
        </div>
    </>
  );
}

export default Dashboard;
